import { FormFieldResponseDTO } from '@/api/base/DTOs';
import { IFormBase, IFormCheckbox } from '@/forms/typings';
import { CheckboxFormFieldBuilder } from '@/forms/builders';
import { adaptFormFieldResponseToValue } from '../utilities/formFieldResponseToValue.adapter';
import { formApiAdapterRegistry } from '../registry/form-api-adapter.registry';

/**
 * Adapts a FormFieldResponseDTO to a CheckboxFormField
 * Handles boolean/checkbox field types
 */
export const adaptFormFieldResponseToCheckboxFormField = (
  formFieldResponse: FormFieldResponseDTO,
  parentFieldId?: IFormBase['fieldId'],
): IFormCheckbox => {
  let checkboxFormField = new CheckboxFormFieldBuilder()
    .fieldId(formFieldResponse.fieldID)
    .name(formFieldResponse.fieldID)
    .label(formFieldResponse.label ?? formFieldResponse.name)
    .readonly(formFieldResponse.readonly || !formFieldResponse.isEditable)
    .value(adaptFormFieldResponseToValue(formFieldResponse) as boolean)
    .hasAnyValue(formFieldResponse.hasAnyValue)
    .notApplicable(formFieldResponse.notApplicable)
    .showNotApplicable(formFieldResponse.showNotApplicable)
    .size(formFieldResponse.itemSize);

  if (formFieldResponse.hint) {
    checkboxFormField = checkboxFormField.hint(formFieldResponse.hint);
  }

  if (formFieldResponse.hintImageUrl) {
    checkboxFormField = checkboxFormField.hintImageUrl(
      formFieldResponse.hintImageUrl,
    );
  }

  const checkboxFieldValidations =
    formApiAdapterRegistry.adaptGeneric(
      formFieldResponse.restriction,
    ) as IFormCheckbox['validations'];

  if (checkboxFieldValidations) {
    checkboxFormField = checkboxFormField.validations(checkboxFieldValidations);
  }

  return checkboxFormField.parentFieldId(parentFieldId).build();
};
